// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YO-z","isFullWidth":"ZO-z","landingPageVideo":"_O-z","play":"aP-z","iframeVideo":"bP-z","playHidden":"cP-z","fullwidth":"dP-z"};